import {
  SET_THEME
} from '../actions'

const initialState = {
  themeName: 'default',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        themeName: action.themeName,
      }
    default:
      return state
  }
}

export default reducer
